<form *ngIf="showButton" class="equipment-notes-footer" [formGroup]="form">
  <div class="row">
    <div class="col-6">
      <p
        style="
          color: #15152e;
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 0;
        "
      >
        {{ 'clockHour.shiftsBreaks' | translate }}
      </p>
    </div>
    <div class="col-6" style="text-align: right">
      <button
        class="add-hours-btn"
        [disabled]="!form.valid || disabled"
        (click)="addDate()"
      >
        {{ 'clockHour.addBreak' | translate }}
        <img src="/assets/images/gl_plus-circle.svg" alt="Añadir" />
      </button>
    </div>
  </div>
  <ng-container formArrayName="dates">
    <div
      *ngFor="let datesForm of dates.controls; let i = index"
      [formGroup]="datesForm"
    >
      <div class="shift-wrapper">
        <div class="inputs">
          <div class="inputs-container">
            <span class="custom-tooltip bottom textLeft">
              <div
                class="time-input-wrapper"
                [ngClass]="{ disabled: disabled }"
              >
                <input
                  class="form-control"
                  id="startDate"
                  aria-describedby="startDateHelp"
                  formControlName="startDate"
                  [placeholder]="'clockHour.selectProject' | translate"
                  matInput
                  mask="Hh:m0"
                  [showMaskTyped]="true"
                  [dropSpecialCharacters]="false"
                  [disabled]="disabled"
                  (change)="onChangeEvent(i)"
                  (blur)="onChangeEvent(i)"
                />
                <div class="time-list-wrapper" *ngIf="startTimePicker === i">
                  <div class="time-list">
                    <button
                      *ngFor="let item of hours"
                      [ngClass]="{ active: hour === item.hour }"
                      (click)="hourChange(item.hour)"
                    >
                      {{ item.hour }}
                    </button>
                  </div>
                  <div class="time-list">
                    <button
                      *ngFor="let item of minutes"
                      [ngClass]="{ active: min === item.min }"
                      (click)="minutesChange(item.min)"
                    >
                      {{ item.min }}
                    </button>
                  </div>
                  <mat-icon class="set-time" (click)="setTime(i, 'startDate')"
                    >check</mat-icon
                  >
                </div>
              </div>
            </span>

            <span class="custom-tooltip bottom textLeft">
              <div
                class="time-input-wrapper"
                [ngClass]="{ disabled: disabled }"
              >
                <input
                  class="form-control"
                  id="endDate"
                  aria-describedby="endDateHelp"
                  formControlName="endDate"
                  [placeholder]="
                    'clockHour.create.form.endDatePlaceholder' | translate
                  "
                  matInput
                  mask="Hh:m0"
                  [showMaskTyped]="true"
                  [dropSpecialCharacters]="false"
                  [disabled]="disabled"
                  (change)="onChangeEvent(i)"
                  (blur)="onChangeEvent(i)"
                />
                <div *ngIf="endTimePicker === i" class="time-list-wrapper">
                  <div class="time-list">
                    <button
                      *ngFor="let item of hours"
                      [ngClass]="{ active: hour === item.hour }"
                      (click)="hourChange(item.hour)"
                    >
                      {{ item.hour }}
                    </button>
                  </div>
                  <div class="time-list">
                    <button
                      *ngFor="let item of minutes"
                      (click)="minutesChange(item.min)"
                      [ngClass]="{ active: min === item.min }"
                    >
                      {{ item.min }}
                    </button>
                  </div>
                  <mat-icon class="set-time" (click)="setTime(i, 'endDate')"
                    >check</mat-icon
                  >
                </div>
              </div>
            </span>
          </div>
        </div>

        <div class="button-delete">
          <div class="container-actions" *ngIf="!disabled">
            <img
              *ngIf="!isMobile"
              src="/assets/icons/gl_trash.svg"
              (click)="delete(i)"
            />
            <div class="delete-text" *ngIf="isMobile" (click)="delete(i)">
              {{ 'clockHour.deleteShift' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="break-wrapper">
        <input
          class="form-control"
          id="reason"
          aria-describedby="reasonHelp"
          formControlName="reason"
          [placeholder]="'clockHour.placeholderBreak' | translate"
          matInput
          [disabled]="disabled"
          (change)="changeReason(i)"
        />
      </div>
    </div>
  </ng-container>
</form>
